import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class LegacyRoute extends Route {
  @service router;
  model() {
    this.router.transitionTo('index');
  }
}
